import React, { useEffect } from "react";
import { PreviewLayout } from ".";
import { FeedbackFormPreview, FeedbackReviewPreview } from "../QRFeedback";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { PreviewSource } from "../QRPreview/types";
import { QRFeedbackProvider } from "@/contexts/QRFeedbackContext";

export default function PreviewFeedback(props: QRProps<"feedback">) {
  const isEditor = props?.source === PreviewSource.editor;

  const qrEditorContextData = React.useContext<QREditorContextProps<"feedback">>(QREditorContext);

  const data = props?.data || qrEditorContextData?.qrData.data;
  const isInitPreview = props?.initPreview;

  const { categories } = data;

  React.useEffect(() => {
    //TODO: QR-3762: NO lo he probado pero ya se usaba en otros QRs para validar
    // avoid go to next step if a category hasn't been selected
    if (!isInitPreview) {
      const categoryExist = categories && categories?.length > 0;
      !categoryExist
        ? qrEditorContextData.setValidationError(true)
        : qrEditorContextData.setValidationError(false);
    }
  }, [data]);

  useEffect(() => {
    if (data.typeName === "Feedback") {
      qrEditorContextData.setQrData({
        ...qrEditorContextData.qrData,
        data: data,
      });
    }
  }, []);

  return (
    <PreviewLayout
      page="feedback"
      dataQA="preview-feedback-container"
      includeBrowser
      initPreview={isInitPreview}>
      <div className="qr-content--feedback">
        <QRFeedbackProvider>
          {isInitPreview ? (
            /* vista del preview en el editor y sin empezar a rellenar el form*/
            <FeedbackFormPreview
              data={data}
              isInitPreview={isInitPreview}
              isEditor={isEditor}
            />
          ) : (
            /* vista del preview cuando se ha rellenado el form y en /p /qr*/
            <FeedbackReviewPreview
              data={data}
              isInitPreview={isInitPreview}
            />
          )}
        </QRFeedbackProvider>
      </div>
    </PreviewLayout>
  );
}
